export default __webpack_public_path__ + "static/media/ic_archive.ec193e3d.svg";